module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/inspiration-elite-reward-100.53a51e3b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/inspiration-elite-reward-100.png
// module id = 3786
// module chunks = 11